// @readonly
// @enum

export const API_Content = Object.freeze({
  ADD_NEW_BLOG: "/UnitContent/Blog/InsertNewArticle",
  ADD_NEW_SLIDER: "/UnitContent/Slider/InsertNewSlide",
  FETCH_SLIDER_LIST: "/UnitContent/Slider/SlidesList",
  CHANGE_SLIDE_STATUS: "/UnitContent/Slider/ChangeSlideStatus",
  UPDATE_SLIDER: "/UnitContent/Slider/UpdateSlide",
  ADD_CATEGORY_QUESTION: "/UnitContent/FAQ/InsertNewCategory",
  GET_CATEGORY_LIST: "/UnitContent/FAQ/CategoriesList",
  DELETE_CATEGORY: "/UnitContent/FAQ/DeleteCategory",
  UPDATE_CATEGORY: "/UnitContent/FAQ/UpdateCategory",
  GET_ASK_QUESTION_LIST: "/UnitContent/FAQ/AskQuestionsList",
  DELETE_ASK_QUESTION: "/UnitContent/FAQ/DeleteAskQuestion",
  UPDATE_ASK_QUESTION: "/UnitContent/FAQ/UpdateAskQuestion",
  INSERT_NEW_ASK_QUESTION: "/UnitContent/FAQ/InsertNewAskQuestion",
  INSERT_NEW_PROPERTY: "/UnitContent/Property/InsertNewProperty",
  GET_PROPERTY_LIST: "/UnitManagement/AllUser/ListProperties",
  INSERT_NEW_NOTIFICATION: "/UnitMessaging/WebNotification/send",
  DELETE_PROPERTY_LEVEL_ONE: "/UnitContent/Property/DeleteProperty",
  UPDATE_PROPERTY_LEVEL_ONE: "/UnitContent/Property/UpdateProperty",
  INSERT_NEW_PROPERTY_LEVEL_TWO: "/UnitContent/Property/InsertNewFeatureValue",
  GET_ALL_PROPERTY_LIST_LEVEL_TOW: "/UnitManagement/AllUser/ListFeatureValues",
  DELETE_PROPERTY_LEVEL_TWO: "/UnitContent/Property/DeleteFeatureValue",
  UPDATE_PROPERTY_LEVEL_TWO: "/UnitContent/Property/UpdateFeatureValue",

  slider: {
    GET_SLIDER_OPTION: "/UnitContent/Slider/GetSlideLocations",
  },

  templateText: {
    GET_TEMPLATE_LIST: "/UnitContent/Product/TelegramBotTemplateList",
    ADD_TEMPLATE_TEXT: "/UnitContent/Product/SetTelegramBotTemplate",
    DELETE_TEMPLATE_TEXT: "/UnitContent/Product/DeleteTelegramBotTemplate",
    UPDATE_TEMPLATE_TEXT: "/UnitContent/Product/UpdateTelegramBotTemplate",
  },

  blog: {
    GET_BLOG_LIST: "/UnitContent/Blog/BlogCategoriesList",
    ADD_NEW_BLOG_CATEGORY: "/UnitContent/Blog/InsertNewBlogCategory",
    UPDATE_BLOG_CATEGORY: "/UnitContent/Blog/UpdateBlogCategory",
    DELETE_BLOG_CATEGORY: "/UnitContent/Blog/DeleteBlogCategory",
    GET_BLOG_TABLE: "/UnitContent/Blog/ArticlesList",
    DELETE_BLOG: "/UnitContent/Blog/DeleteArticle",
    GET_LIKE_MEMEBER_BLOG: "/UnitContent/Blog/ArticleLikesList",
    EDIT_BLOG: "/UnitContent/Blog/UpdateArticle",
  },

  notification: {
    GET_NOTIFICATION_LIST:
      "/UnitMessaging/WebNotification/WebNotificationsList",
  },

  area_coverd: {
    country: {
      ADD_NEW_COUNTRY: "/UnitContent/CoveredArea/InsertNewCountry",
      DELTE_COUNTRY: "/UnitContent/CoveredArea/DeleteCountry",
      UPDATE_COUNTRY: "/UnitContent/CoveredArea/UpdateCountry",
      GET_COUNTRY_LIST: "/UnitContent/CoveredArea/CountriesList",
    },
    province: {
      ADD_NEW_PROVINCE: "/UnitContent/CoveredArea/InsertNewProvince",
      DELTE_PROVINCE: "/UnitContent/CoveredArea/DeleteProvince",
      UPDATE_PROVINCE: "/UnitContent/CoveredArea/UpdateProvince",
      GET_PROVINCE_LIST: "/UnitContent/CoveredArea/ProvincesList",
      GET_COUNTRY_OPTION: "/UnitContent/CoveredArea/CountriesList",
    },
    city: {
      ADD_NEW_CITY: "/UnitContent/CoveredArea/InsertNewCity",
      DELTE_CITY: "/UnitContent/CoveredArea/DeleteCity",
      UPDATE_CITY: "/UnitContent/CoveredArea/UpdateCity",
      GET_CITY_LIST: "/UnitContent/CoveredArea/CitiesList",
      GET_PROVINCE_OPTION: "/UnitContent/CoveredArea/ProvincesList",
    },
    area: {
      ADD_NEW_AREA: "/UnitContent/CoveredArea/InsertNewArea",
      DELTE_AREA: "/UnitContent/CoveredArea/DeleteArea",
      UPDATE_AREA: "/UnitContent/CoveredArea/UpdateArea",
      GET_AREA_LIST: "/UnitContent/CoveredArea/AreasList",
    },
  },

  product_category: {
    productLevel: {
      INSERT_NEW_CATEGORY: "/UnitContent/Category/InsertNewCategory",
      UPDATE_CATEGORY: "/UnitContent/Category/UpdateCategory",
      DELETE_CATEGORY: "/UnitContent/Category/DeleteCategory",
      GET_LEVEL_ONE_LIST: "/UnitManagement/AllUser/ListCategoriesLevelOne",
      GET_LEVEL_TWO_LIST: "/UnitManagement/AllUser/ListCategoriesLevelTwo",
      GET_LEVEL_TREE_LIST: "/UnitManagement/AllUser/ListCategoriesLevelThree",
    },
    Brand: {
      INSERT_NEW_BRAND: "/UnitContent/Category/InsertNewBrand",
      UPDATE_BRAND: "/UnitContent/Category/UpdateBrand",
      DELETE_BRAND: "/UnitContent/Category/DeleteBrand",
      GET_BRAND_LIST: "/UnitContent/Category/BrandsList",
      SHOW_BRAND: "",
    },
    gender: {
      INSERT_NEW_GENDER: "/UnitContent/Category/InsertNewGender",
      UPDATE_GENDER: "/UnitContent/Category/UpdateGender",
      DELETE_GENDER: "/UnitContent/Category/DeleteGender",
      GET_GENDER_LIST: "/UnitContent/Category/GendersList",
      SHOW_GENDER: "",
    },
    occation: {
      INSERT_NEW_OCCATION: "/UnitContent/Category/InsertNewOccasion",
      UPDATE_OCCATION: "/UnitContent/Category/UpdateOccasion",
      DELETE_OCCATION: "/UnitContent/Category/DeleteOccasion",
      CHANGE_OCCATION_STATUS: "/UnitContent/Category/ChangeOccasionStatus",
      GET_OCCATION_LIST: "/UnitContent/Category/OccasionList",
      SHOW_OCCATION: "",
    },
  },

  product: {
    active_product: {
      GET_ACTIVE_PRODUCT: "/UnitContent/Product/ProductsList",
      DELETE_ACTIVE_PRODUCT: "",
      ROCKET_ACTIVE_PRODUCT: "",
      DEACTIVE_ACTIVE_PRODUCT: "",
      EDIT_ACTIVE_PRODUCT: "",
    },
    finished_prodcut: {
      GET_FINISHED_PRODUCT: "/UnitContent/Product/ProductsList",
      DELETE_FINISHED_PRODUCT: "",
      ROCKET_FINISHED_PRODUCT: "",
      APPLY_TO_EXIST_PRODUCT: "",
    },
    rocked_product: {
      GET_ROCKED_LIST: "/UnitContent/Product/ProductsList",
      DELETE_ROCKET_PRODUCT: "/UnitContent/Product/DeleteProduct",
      CHANGE_ROCKET_PRODUCT_STATUS: "/UnitContent/Product/ChangeProductStatus",
    },
    rocked_inventory: {},
    add_product: {
      GET_INVENTROY_LIST: "/UnitManagement/AllUser/ListWarehouseTypes",
      GET_SUPPLIER_LIST: "/UnitManagement/AllUser/ListSupplier",
      UPLOAD_IMG_RICH_TEXT_EDITOR: "",
      INSERT_NEW_PRODUCT: "/UnitContent/Product/InsertNewProduct",
    },
    edit_product: {
      GET_PRODUCT_DETAIL: "/UnitContent/Product/ShowDetailProduct",
      EDIT_PRODUCT: "/UnitContent/Product/UpdateInsertProduct",
      DELETE_CHILD_IMAGE_PRODUCT: "/UnitContent/Product/DeleteProductMorePhoto",
    },
  },

  my_product: {
    GET_MY_PRODUCT_LIST: "/UnitContent/Product/ProductsList",
    GET_PRODUCT_CHANGE_STATUS:
      "/UnitContent/Product/ChangeProductInventoryStatus",
    DELETE_PRODUCT: "/UnitContent/Product/DeleteProduct",
    GET_LADDER_PRODUCT: "/UnitContent/Product/LadderProduct",
    SHARE_PRODUCT: "/UnitContent/Product/ActiveProductView",
    SHARE_PRODUCTS: "/UnitContent/Product/AllActiveProductView",
    BACK_PRODUCT: "/UnitContent/Product/BackProduct",
    Add_ROCKET_PRODUCT: "/UnitContent/Product/ChangeStoreStatus",
    GET_ROCKET_PRODUCT: "/UnitContent/Product/ChangeStoreStatusList",
    GET_ALL_BRANDS: "/UnitManagement/AllUser/ListBrands",
    SHARE_PRODUCT_TELEGRAM: "/UnitContent/Product/SendToBot",
  },

  seo: {
    GET_SEO_INFO: "/UnitContent/Seo/ShowSeo",
    EDIT_SEO: "/UnitContent/Seo/UpdateSeo",
  },

  holiday: {
    INSERT_NEW_HOLIDAY: "/UnitManagement/Holiday/InsertNewHoliday",
    UPDATE_HOLIDAY: "/UnitManagement/Holiday/UpdateHoliday",
    DELETE_HOLIDAY: "/UnitManagement/Holiday/DeleteHoliday",
    GET_LIST_HOLDIAY: "/UnitManagement/Holiday/HolidaysList",
  },
});

// IdRefrenceSeo,locationSeo,IdUser
